import { BrowserRouter } from 'react-router-dom'
import { Provider, useSelector } from 'react-redux'
import store from './redux/store'
import Router from './router'
import { AbilityContext } from './utility/context/Can'
import { selectAbility } from './redux/slices/authSlice'

const AbilityBridge = ({ children }) => {
  const ability = useSelector(selectAbility)
  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  )
}

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <AbilityBridge>
        <Router />
      </AbilityBridge>
    </BrowserRouter>
  </Provider>
)

export default App